const applyCurrencyBrand = (schema) => schema.brand();
var Currency;
(function (Currency) {
    Currency.ZERO = 0;
    function round(value) {
        if (Number.isNaN(value))
            return Currency.ZERO;
        return (Math.round(value * 100) / 100);
    }
    Currency.round = round;
    function add(a, b, ...rest) {
        return round([a, b, ...rest].reduce((acc, v) => acc + v, 0));
    }
    Currency.add = add;
    function subtract(a, b) {
        return round(a - b);
    }
    Currency.subtract = subtract;
    function sum(values) {
        return round(values.reduce((a, b) => a + b, 0));
    }
    Currency.sum = sum;
    function parse(value, defaultValue = 0) {
        if (value === null || value === undefined) {
            return round(defaultValue);
        }
        if (typeof value === "number") {
            return Number.isNaN(value) ? round(defaultValue) : round(value);
        }
        const trimmed = String(value).trim();
        if (trimmed === "" || trimmed === "-") {
            return round(defaultValue);
        }
        const isNegativeParens = trimmed.startsWith("(") && trimmed.endsWith(")");
        const cleaned = trimmed.replace(/[$\u20AC\u00A3\u00A5,\s()]/g, "");
        const parsed = parseFloat(cleaned);
        if (Number.isNaN(parsed)) {
            return round(defaultValue);
        }
        const result = isNegativeParens ? -Math.abs(parsed) : parsed;
        return round(result);
    }
    Currency.parse = parse;
    function sumParsed(values) {
        return sum(values.map((v) => parse(v)));
    }
    Currency.sumParsed = sumParsed;
})(Currency || (Currency = {}));

export { Currency, applyCurrencyBrand };
